import {Component, EventEmitter, Input, OnChanges, OnInit, Output, SimpleChanges} from '@angular/core';
import {FormBuilder, FormGroup, Validators} from '@angular/forms';
import {RiderNotesInformationService} from '../../../../../core/services/rider-notes-information.service';
import {T2LoadingService} from '../../../../../trip2-theme/components/t2-loading/t2-loading.service';
import {RiderNotesModel} from '../../../../riders/rider-notes/rider-notes.model';

@Component({
  selector: 'app-create-note',
  templateUrl: './create-note.component.html',
  styleUrls: ['./create-note.component.scss']
})
export class CreateNoteComponent implements OnInit, OnChanges {

  private form: FormGroup;
  private riderNoteData: RiderNotesModel;
  private text: string;
  private editNote: boolean;

  @Input() riderId: number;
  @Input() modalVisible: boolean;
  @Input() dataNote: Object;
  @Output() closed = new EventEmitter<boolean>();
  @Output() successfully = new EventEmitter<Object>();

  constructor(
    private fb: FormBuilder,
    private _service: RiderNotesInformationService,
    private _loading: T2LoadingService
  ) {
    this.createForm();
  }

  ngOnInit() {
  }

  ngOnChanges(changes: SimpleChanges): void {
    // tslint:disable-next-line:forin
    for (const key in changes) {
      if (key === 'dataNote') {if (changes[key].currentValue) {
        this.isEdition(changes[key].currentValue);
        }
      }
    }
  }

  /**
   * @name isEdition
   * @description define si es para editar - define if it is to edit
   * @param data = dataNote
   */
  isEdition(data) {
    if (Object.keys(data).length) {
      this.editNote = true;
      this.form.get('note').setValue(`${data.note.description}`);
    }else {this.editNote = false; }
  }

  /**
   * @name createForm
   * @description crea form y escucha campo - create form and listen to field
   */
  createForm() {
    this.form = this.fb.group({
      note: ['', [Validators.required]]
    });
    this.form.get('note').valueChanges.subscribe(val => {
      this.text = val;
    });
  }

  /**
   * @name cancelNote
   * @description cancela y emite si es modal - cancel and issue if modal
   */
  cancelNote() {
    this.resetForm();
    if (this.modalVisible) {
      this.closed.emit(true);
    }
  }

  /**
   * @name saveNote
   * @description Crea o actualiza una nota - Create or update a note
   */
  saveNote() {
    if (this.editNote) {
      this.assignValues(true);
      this._service.put(this.riderNoteData).subscribe(
        success => {this.successfully.emit(success); this.resetForm(); },
        error => {this.successfully.emit(error); }
        );
    }
    if (!this.editNote) {
      this.assignValues(false);
      this._service.post(this.riderNoteData).subscribe(
          success => {this.successfully.emit(success); this.resetForm(); },
          error => {this.successfully.emit(error); }
        );
    }
  }

  /**
   * @name assignValues
   * @description asigna valores al objeto a enviar - assign values ​​to the object to send
   * @param edit = si es edición
   */
  assignValues(edit: boolean): void {
    if (edit) {
      this.riderNoteData = <RiderNotesModel>{
        riderid       : this.riderId,
        ridernoteid   : this.dataNote['ridernoteid'],
        note    : {
          noteid      : this.dataNote['note'].noteid,
          notetypeid  : this.dataNote['note'].notetypeid,
          description : this.text
        }
      };
    }else {
      this.riderNoteData = <RiderNotesModel>{
        riderid : this.riderId,
        note    : {description: this.text}
      };
    }
  }

  /**
   * @name resetForm
   * @description borra los datos y resetea el form - delete the data and reset the form
   */
  resetForm() {
    this.editNote = undefined;
    this.text = undefined;
    this.riderNoteData = <RiderNotesModel>{};
    this.form.reset();
  }
}



// WEBPACK FOOTER //
// ./src/app/pages/rider/components/rider-notes-information/create-note/create-note.component.ts